import { formatUom } from '@wra/unit/lib/utils/formatUom';

import { FormattedUom } from '@/common/uom/models/formattedUom';

export function generateFormattedUom(uom: string): FormattedUom {
  return {
    label: `${uom.substr(0, 1).toUpperCase()}${uom.substr(1).toLowerCase()}`,
    suffix: formatUom(uom),
  };
}
